/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempSocialTab: {
  name: 'temp-social-tab';
  data: string;
} = {
  name: 'temp-social-tab',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 6a6 6 0 1 0 0 12h8a6 6 0 0 0 0-12H8Zm-4 6a4 4 0 0 1 4-4h8a4 4 0 0 1 0 8H8a4 4 0 0 1-4-4Zm5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
